import {Component,} from '@angular/core';
import {HttpClientService} from "../../../core/services/http-client.service";
import {ToastService} from "../../../core/services/toast.service";
import {CommonService} from "../../../core/services/common.service";
import {environment} from "../../../../environments/environment";
import {combineLatest as observableCombineLatest, Observable} from "rxjs";
import {ActivatedRoute} from "@angular/router";

@Component({
  selector: 'app-user-profile',
  templateUrl: './user-profile.component.html',
  styleUrl: './user-profile.component.css'
})
export class UserProfileComponent {
  visible: boolean=false;
  fullName: any;
  address: any;
  customer: any;
  loading: boolean;
  addresses: any[] = [];

  constructor(private http: HttpClientService, private toast: ToastService,  private store: CommonService,
              public common: CommonService, private route: ActivatedRoute,) {
    this.customer = this.store.getStorage('customer');
    if (this.customer.profileImageId) {
      this.customer.profileImageUrl = `${environment.API_ENDPOINT}document/${this.customer.profileImageId}`;
    }
  }


  ngOnInit(): void {
    this.common.setStorage("customer", this.customer);
    observableCombineLatest([
      this.route.data,
      this.route.queryParams,
      this.route.params,
    ]).subscribe((bothParams) => {

      this.getCustomerById(this.customer.id)
        .subscribe(data => {
          this.loading = false;
          if (data['responseStatus'].toLowerCase() == 'success') {
            this.customer = data['response'];
            this.user.mobile = this.customer.mobileNumber
            if(this.customer.profileImageId) this.customer.profileImageUrl = `${environment.API_ENDPOINT}document/${this.customer.profileImageId}`;
          }
        });
    });
    this.getUserAddresses(this.customer.id);
  }
  openDialog(): void {
    this.visible = true;
    this.editModal=true;
  }

  editModal: boolean=false;
  changeModal: boolean=false;
  public updateProfileData(customer): Observable<any> {
    return this.http.post("store/updateCustomer", customer);
  };

  public user: any = {
  }
  public getCustomerById(id: Number): Observable<any> {
    return this.http.get(`store/getCustomerById/${id}`);
  };

  private getUserAddresses(userID) {
    this.http.get(`store/addresses/${userID}`)
      .subscribe((res) => {
        if (res.statusCode == 200) {
          this.addresses = [];
          for (let address of res.response) {
            if(address.default) {
              address.fullAddress = this.getFullAddress(address)
              this.addresses.push(address);
            }
          }
        }
      });
  }
  getFullAddress(address: any) {
    let add = '';
    add += address.line1 ? address.line1+', ' : ''
    add += address.line2 ? address.line2+', ' : ''
    add += address.landmark ? address.landmark+', ' : ''
    add += address.city ? address.city+', ' : ''
    add += address.state ? address.state+', ' : ''
    add += address.pinCode ? address.pinCode : ''
    return add;
  }
  isEmailFilled(): boolean {
    return !this.customer.emailId;
  }
  isNameFilled(): boolean {
    return !this.customer.fullName;
  }

  submitForm(): void {
    this.http.post('store/updateCustomer', this.customer).subscribe(
      response => {
        this.toast.success('Profile updated successfully');
        this.store.setStorage('customer', this.customer);
        this.visible = false;
      },
      error => {
        this.toast.error('Failed to update profile');
      }
    );
  }

}
